// extracted by mini-css-extract-plugin
export default {"baseWidth":"Common_baseWidth__LAFxO","circleProfile_big":"Common_circleProfile_big__C7GS2","toCenter":"Common_toCenter__RXoHp","toLeft":"Common_toLeft__Zqd8B"};